const unavailableFor = ({ isReservedMe, isHoldedMe }) => {
    if (isReservedMe) {
        return 'reserved_me';
    } else if (isHoldedMe) {
        return 'on_hold_me';
    } else {
        return 'unavailable';
    }
}

export const decorateStates = ({ states, isReservedMe, isHoldedMe, isBorrowedMe }) => {
    const trimmed = states.split(',').map(s => s.trim());

    if (trimmed.includes('RESERVED') && trimmed.includes('ON_HOLD')) {
        return unavailableFor({ isReservedMe, isHoldedMe });
    } else if (trimmed.includes('ON_HOLD')) {
        return isHoldedMe ? 'on_hold_me' : 'on_hold';
    } else if (trimmed.includes('RESERVED')) {
        return isReservedMe ? 'reserved_me' : 'reserved';
    } else if (trimmed.includes('BORROWED')) {
        return isBorrowedMe ? 'borrowed_me' : 'borrowed';
    }

    return 'available';
};
